import React from "react";
import { cn } from "../../utils/cn";

const Input = React.forwardRef(({
    className,
    type = "text",
    label,
    description,
    error,
    required = false,
    id,
    ...props
}, ref) => {
    const inputId = id || `input-${Math.random()?.toString(36)?.substr(2, 9)}`;

    const baseInputClasses = "flex w-full rounded-md border border-border bg-input px-4 font-oranienbaum text-foreground ring-offset-background file:border-0 file:bg-transparent file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

    if (type === "checkbox") {
        return (
            <input
                type="checkbox"
                className={cn(
                    "h-5 w-5 rounded border border-border bg-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                    className
                )}
                ref={ref}
                id={inputId}
                {...props}
            />
        );
    }

    if (type === "radio") {
        return (
            <input
                type="radio"
                className={cn(
                    "h-5 w-5 rounded-full border border-border bg-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                    className
                )}
                ref={ref}
                id={inputId}
                {...props}
            />
        );
    }

    return (
        <div className="space-y-2">
            {label && (
                <label
                    htmlFor={inputId}
                    className={cn(
                        "font-semibold font-oranienbaum leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
                        error ? "text-error" : "text-foreground"
                    )}
                    style={{ fontSize: 'var(--fs-filter-label)' }}
                >
                    {label}
                    {required && <span className="text-error ml-1">*</span>}
                </label>
            )}

            <input
                type={type}
                className={cn(
                    baseInputClasses,
                    error && "border-error focus-visible:ring-error",
                    className
                )}
                style={{ fontSize: 'var(--fs-form-field)', minHeight: 'var(--control-height-md)', paddingTop: '0.75rem', paddingBottom: '0.75rem' }}
                ref={ref}
                id={inputId}
                {...props}
            />

            {description && !error && (
                <p className="font-oranienbaum text-muted-foreground" style={{ fontSize: 'var(--fs-sm)' }}>
                    {description}
                </p>
            )}

            {error && (
                <p className="font-oranienbaum text-error" style={{ fontSize: 'var(--fs-sm)' }}>
                    {error}
                </p>
            )}
        </div>
    );
});

Input.displayName = "Input";

export default Input;